module.exports = {
  init: require("./init"),
  compile: require("./compile"),
  migrate: require("./migrate"),
  deploy: require("./deploy"),
  build: require("./build"),
  test: require("./test"),
  debug: require("./debug"),
  opcode: require("./opcode"),
  console: require("./console"),
  develop: require("./develop"),
  create: require("./create"),
  install: require("./install"),
  publish: require("./publish"),
  //digest: require("./digest"),
  networks: require("./networks"),
  watch: require("./watch"),
  serve: require("./serve"),
  exec: require("./exec"),
  unbox: require("./unbox"),
  version: require("./version"),
};



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-core/lib/commands/index.js
// module id = 179
// module chunks = 0